import { render } from "./Footer.vue?vue&type=template&id=1595b1cf&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1595b1cf&scoped=true&lang=css"

import exportComponent from "/Users/adamchaarawi/Desktop/dev/adams-personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1595b1cf"]])

export default __exports__